import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Initialize Angular

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);

(() => {
  const firstScript = document.scripts[0];
  const scriptElement = document.createElement('script');
  scriptElement.src = `https://maps.googleapis.com/maps/api/js?key=${environment.firebase.apiKey}`;

  if (firstScript.parentNode) {
    firstScript.parentNode.insertBefore(scriptElement, firstScript);
  }
})();



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/main.ts